import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { JsonApiService } from './api/json-api.service'
import { LayoutService } from '../shared/layout/layout.service'
import { VoiceControlService } from '../shared/voice-control/voice-control.service'
import {SoundService} from '../shared/sound/sound.service';

import { throwIfAlreadyLoaded } from './guards/module-import-guard';
import {VoiceRecognitionService} from '../shared/voice-control/voice-recognition.service';
import {TabsModule, ProgressbarModule, TooltipModule, BsDropdownModule, AlertModule} from 'ngx-bootstrap';
import {IsbnService} from '../+app-custom/services/isbn.service';
import {ReportService} from '../+app-custom/services/report.service';
import {PublicationService} from '../+app-custom/services/publication.service';
import {UserService} from '../+app-custom/services/user.service';
import {StatisticService} from '../+app-custom/services/statistic.service';

@NgModule({
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
    BsDropdownModule.forRoot(),
    ProgressbarModule.forRoot(),
    AlertModule.forRoot(),
    TabsModule.forRoot(),
  ],
  exports: [
    HttpClientModule
  ],
  declarations: [],
  providers: [
    JsonApiService,
    LayoutService,
    VoiceControlService,
    VoiceRecognitionService,
    SoundService,
      UserService,
      IsbnService,
      ReportService,
      PublicationService,
      StatisticService
  ]
})
export class CoreModule {
  constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
 }



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts